import { useCallback, useMemo } from 'react'

import { TutorialStatus, useTutorialStore } from '@wwt/core/tutorial'
import { Offer } from '@wwt/entities/search-response'
import { limitDisplayPhotos } from '@wwt/shared/utils'
import { useSearchResponseStore } from '@wwt/store/searchResponse'

export const useOfferCard = (
	offer: Offer,
	onLocationClickCallback?: (id: string) => void,
	onNavigation?: () => void
) => {
	const tutorialStatus = useTutorialStore.use.tutorialStatus()
	const incrementStep = useTutorialStore.use.incrementStep()

	const setSelectedOfferId = useSearchResponseStore.use.setSelectedId()

	const isTutorialGoing = tutorialStatus === TutorialStatus.GOING

	const onOfferCardLocationClick = useCallback(() => {
		if (isTutorialGoing) return

		onLocationClickCallback?.(offer.IDs.nonPersistingOfferId)
	}, [isTutorialGoing, offer.IDs.nonPersistingOfferId, onLocationClickCallback])

	const onLinkClick = (event: React.MouseEvent<HTMLDivElement>) => {
		const isLinkElementClicked = event.target instanceof HTMLAnchorElement
		if (!isLinkElementClicked) return

		if (isTutorialGoing) {
			incrementStep()
		}

		setSelectedOfferId(offer.IDs.nonPersistingOfferId)
	}

	const onImageClick = () => {
		if (isTutorialGoing) {
			incrementStep()
		}

		setSelectedOfferId(offer.IDs.nonPersistingOfferId)
		onNavigation?.()
	}

	const images = useMemo(() => {
		return (
			limitDisplayPhotos(offer.roomStatic.images) ??
			limitDisplayPhotos(offer.hotelStatic.images) ??
			[]
		)
	}, [offer])

	return {
		onLinkClick,
		onImageClick,
		onOfferCardLocationClick,
		isLocationDisabled: isTutorialGoing,
		images
	}
}
